import { render } from "./LandingNextCompetition.vue?vue&type=template&id=5aadca86&scoped=true&ts=true"
import script from "./LandingNextCompetition.vue?vue&type=script&lang=ts"
export * from "./LandingNextCompetition.vue?vue&type=script&lang=ts"

import "./LandingNextCompetition.vue?vue&type=style&index=0&id=5aadca86&scoped=true&lang=css"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aadca86"]])

export default __exports__